import {AppController} from '../controller/app.controller';
import AppTemplate from '../../template/app.html'

export const AppComponent = {
    template: AppTemplate,
    controller: AppController,
    controllerAs: 'appCtrl',
};
